import {
    LearnWhyDialog,
    LearnWhyDialogProps,
} from '@rhg/components/learn-why-dialog';
import { PropsWithChildren, createContext, useCallback, useState } from 'react';

type LearnWhyProps = Omit<LearnWhyDialogProps, 'onClose' | 'isOpen'>;

export interface LearnWhyDialogState {
    learnWhy: (props: LearnWhyProps) => void;
    isOpen: boolean;
}

export const LearnWhyDialogContext = createContext<LearnWhyDialogState>(null!);

export const LearnWhyDialogProvider = ({ children }: PropsWithChildren) => {
    const [props, setProps] = useState<LearnWhyProps>();

    const onClose = useCallback(() => {
        setProps(undefined);
    }, []);

    const learnWhy = useCallback((props: LearnWhyProps) => {
        setProps(props);
    }, []);

    const isOpen = !!props;

    return (
        <>
            <LearnWhyDialogContext.Provider value={{ isOpen, learnWhy }}>
                {children}
            </LearnWhyDialogContext.Provider>
            {isOpen && (
                <LearnWhyDialog
                    isOpen
                    packProgram={props.packProgram}
                    program={props.program}
                    reason={props.reason}
                    isTopRecommendation={props.isTopRecommendation}
                    packClass={props.packClass}
                    onClose={onClose}
                />
            )}
        </>
    );
};
